export default __webpack_public_path__ + "static/media/Slide18.dc697b9d.JPG";